<template>
    <v-container>
        e-poster
        <application-search-by-date-year @updated="updated" :initialFrom="moment().subtract(1, 'week').unix()" :initialTo="moment().endOf(1, 'day').unix()"></application-search-by-date-year>
        <v-row>
            <v-col>
                <v-data-table :items="emails" :headers="headers" v-model="selected" :loading="emailsLoading" show-select single-select disable-pagination :mobile-breakpoint="0" hide-default-footer>
                    <template v-slot:item.createdAt={item}>
                        <div>{{moment.unix(item.createdAt).format("YYYY-MM-DD HH:mm")}}</div>
                    </template>
                    <template v-slot:item.resent={item}>
                        <div>{{item.resent? 'ja':'nei'}}</div>
                    </template>
                </v-data-table>
            </v-col>
            <v-col>
                <v-row>
                    <v-btn color="success" :disabled="!selected || !selected.length > 0" class="float-left" @click="resendEmail(selected[0])">Send e-post igjen</v-btn>
                </v-row>
                <v-row>
                    <div v-html="selected && selected.length > 0 ? selected[0].html : ''"></div>
                </v-row>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as axios from "axios";
import * as moment from "moment";
export default {
    data() {
        return {
            emails: [],
            emailsLoading: false,
            selected: [],
            headers: [
                { text: "Emne", value: "subject" },
                { text: "Til", value: "to" },
                { text: "Sendt på nytt", value: "resent" },
                { text: "Opprettet", value: "createdAt" }
            ],
            moment: moment
        };
    },
    methods: {
        async updated(from, to) {
            this.emailsLoading = true;
            let fromUnix = moment(from, "YYYY-MM-DD")
                .startOf("day")
                .unix();
            let toUnix = moment(to, "YYYY-MM-DD")
                .endOf("day")
                .unix();

            let response = await axios.get(`/email?from=${fromUnix}&to=${toUnix}`);
            this.emails = response.data;
            this.emailsLoading = false;
        },
        async resendEmail(email) {
            let response = await axios.post(`/email/resend/${email.id}`);
            this.emails.push(response.data);

            email.resent = true;

            this.$store.commit("snackbar", { text: "E-post sendt", color: "success" });
        }
    },
    mounted() {}
};
</script>

<style lang="scss">
</style>